"use client"
import { faBolt, faCircleCheck, faEllipsisV } from "@instadeepai/fontawesome-pro-regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@shared/ui";

import { StatusBadge } from "@/components/status-badge";
import { Module } from "../types";
import { Badge } from "@shared/ui";
import { Card } from "@/components/card";

interface ModuleCardProps extends Module {
  isSelected: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const ModuleCard = ({ title, status, createdBy, tags, isSelected, onClick }: ModuleCardProps) => {
  return (
    <Card
      onClick={onClick}
      className={cn(
        "h-[260px] flex flex-col justify-between",
        {
          "border-[#5D5FEF] shadow-[0px_0px_40px_0px_rgba(100,103,198,0.30)]": isSelected,
          "border-[#EDEEF1]": !isSelected,
        }
      )}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <h1 className="font-semibold text-[#101828] text-xl leading-none">{title}</h1>
          <StatusBadge variant="secondary" className="!text-xs" leftIcon={<FontAwesomeIcon icon={faBolt} />}>
            {status}
          </StatusBadge>
        </div>
        <button className="text-[#98A2B3] hover:text-[#A5A6F6] transition-colors">
          <FontAwesomeIcon icon={faEllipsisV} className="text-[14px]" />
        </button>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-4">
          <p className="font-medium text-[#475467] text-sm">Created By: </p>
          <div className="flex items-center gap-2">
            <img src="/instadeep-logo.svg" alt="x Logo" className="size-6" />
            <p className="font-medium text-[#475467] text-sm">{createdBy}</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => (
            <Badge key={tag.id} variant={tag.type === "InProgress" ? "info" : "purple"} className="font-medium" size="sm" leftIcon={<FontAwesomeIcon icon={faCircleCheck} />}>{tag.name}</Badge>
          ))}
        </div>
      </div>
    </Card>
  )
}
